// Where each AI edit started in this browser is to land (spec G13b, PR E2): kept per viewer and
// Layerize beside the draft, as live's, until the edit settles. Only a hint: a lost one offers the
// edit's result as a new layer instead.
import { z } from "zod";

import { readDraftSlot, writeDraftSlot } from "../../../platform/prefs";
import { draftKey } from "./draft";
import type { EditLanding } from "./edits";

const landings = z.record(z.uuid(), z.object({ layer: z.string().min(1), mode: z.enum(["replace", "add"]) }));

export type Landings = Record<string, EditLanding>;

/** The landings kept for this viewer and Layerize; none without a viewer. */
export function readLandings(viewer: string | null, jobId: string): Landings {
  if (viewer === null) return {};
  return readDraftSlot("layerEdits", draftKey(viewer, jobId), landings) ?? {};
}

export function writeLandings(viewer: string | null, jobId: string, value: Landings): void {
  if (viewer !== null) writeDraftSlot("layerEdits", draftKey(viewer, jobId), value);
}
